"use client";

import { useIsDesktop } from "@/hooks/app/useIsDesktop";
import SearchIcon from "@/components/icons/SearchIcon";
import { Button } from "antd";
import { FC } from "react";
import { useTranslation } from "react-i18next";

type ButtonSearchProps = {
  onClick: () => void;
  compact?: boolean;
  /** Chiếm hết chiều rộng cột chứa nó — dùng khi đứng cùng hàng với field khác (esim-hub__search-bar),
   * tránh minWidth cố định làm tràn cột hẹp. Cùng quy ước với ButtonSearch bên visa. */
  fullWidth?: boolean;
};

const ButtonSearch: FC<ButtonSearchProps> = ({ onClick, compact = false, fullWidth = false }) => {
  const isDesktop = useIsDesktop();
  const { t } = useTranslation();

  const compactStyle = compact
    ? { height: "4.4rem", width: "4.4rem", minWidth: "4.4rem", padding: 0 }
    : fullWidth
      ? { fontSize: "1.5rem" }
      : { height: "4rem", fontSize: "1.5rem", minWidth: "11rem" };

  return (
    <Button
      block={fullWidth || (!isDesktop && !compact)}
      type="primary"
      size="large"
      shape={compact ? undefined : "round"}
      icon={<SearchIcon style={{ fontSize: compact ? "1.6rem" : "1.5rem" }} />}
      style={compactStyle}
      onClick={onClick}
    >
      {compact ? null : isDesktop ? t("common.search_short") : t("common.search")}
    </Button>
  );
};

export default ButtonSearch;
